const notificationBody = (message) => (
  <div>
    <p>
      { message }
    </p>
  </div>
);

export default notificationBody;